import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "children"],
  _excluded2 = ["children", "isMainAppProvider"];
import styled from 'foundations-theming/utils';
import { AppProvider } from '../AppProvider/AppProvider';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledApplication = styled.div.withConfig({
  displayName: "Application__StyledApplication",
  componentId: "jjbgsf-0"
})(({
  $cssStyles
}) => {
  return $cssStyles;
});

/*
 * IMPORTANT:
 * Only "themeless" token props can be passed to `Application`.
 * A top level component like this one can't access the theme
 * since it renders the `ThemeProvider`.
 */

/**
 * This nested component ensures that we can call `useMapTokenPropsToCSS` with the theme available.
 */
const ApplicationWithTokenProps = _ref => {
  let {
      name,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledApplication, Object.assign({
    $cssStyles: cssStyles,
    "data-application-name": name
  }, domProps, {
    children: children
  }));
};
export const Application = _ref2 => {
  let {
      children,
      isMainAppProvider
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(AppProvider, {
    themeName: "canvas",
    themeMode: "light",
    isMainAppProvider: isMainAppProvider,
    children: /*#__PURE__*/_jsx(ApplicationWithTokenProps, Object.assign({}, rest, {
      children: children
    }))
  });
};